export const getBaseUrl = (url) => {
  const { origin } = new URL(url);
  return origin;
};
